(function() {

    'use strict';

    var itxPopupCoverImgCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'itxPopupCoverImgCmpTpl.html',
        controller: itxPopupCoverImgCmpCtrl,
        bindings: {
            data: '<'

        }
    };

    itxPopupCoverImgCmpCtrl.$inject = ['$scope', 'timestampSvc'];

    function itxPopupCoverImgCmpCtrl($scope, timestampSvc) {

        var _this = this;

        $scope.colorText = { 'color': this.data.popup_suscripcion_1 };

        var stringStore = '%STORE%';
        var stringLang = '%LANG%';
        var stringTimestamp = '%TIMESTAMP%';

        if (this.data.popup_suscripcion_2.indexOf('.') > -1) {
            this.pathMedia = window.staticContent + '/media/2017/popup_marketing/' + this.data.popup_suscripcion_2;
            $scope.bgCoverImg = {
                'background-image': 'url(' + this.pathMedia + ')',
                'background-size': 'cover'
            };
        } else {
            $scope.bgCoverImg = { 'background-color': this.data.popup_suscripcion_2 };
        }

        if(this.data.popup_suscripcion_2 === 'image-text-full') {
            _this.urlPolicies = generateHref(_this.data.popup_suscripcion_8);
            _this.title = _this.data.popup_suscripcion_4;
            _this.imageTextFull = true;   
        }

        function generateHref(url) {
            var isDinamicStore = url.indexOf(stringStore) > -1;
            var isDinamicLang = url.indexOf(stringLang) > -1;
            var isDinamicTimestamp = url.indexOf(stringTimestamp) > -1;
            if(isDinamicStore){
                url = url.replace(stringStore, inditex.iStoreId);                
            }
            if(isDinamicLang){
                url = url.replace(stringLang, inditex.iLangId);                
            }
            if(isDinamicTimestamp){
                url = url.replace(stringTimestamp, timestampSvc.getTs() );                
            }
            return url;
        }

    }

    angular.module('itxApp.common')
        .component('itxPopupCoverImg', itxPopupCoverImgCmp);

})();